// Mock function that does nothing.
// Can be used as default React prop
export default function noop(): void {
  // do nothing
}
